import { App } from '@chorepop/ui';
/* @refresh reload */
import { render } from 'solid-js/web';
import { installDevTauriMock } from './dev-tauri-mock';
import { installPublicDemoGuide } from './public-demo-guide';
import './main.css';

// In browser dev, install a fake Tauri invoke() so calls from the UI
// don't error. In Tauri-hosted builds, this is a no-op.
installDevTauriMock();

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root element not found');
}
render(() => <App />, root);
installPublicDemoGuide();
